"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreorderStatusComponent = void 0;
class PreorderStatusComponent {
    // check if shipped date + 4 days is greater to show tracking number
    showOrder(shipedDate) {
        if ((new Date((new Date(shipedDate).setDate(new Date(shipedDate).getDate() + 4)))) > (new Date())) {
            return true;
        }
        else {
            return false;
        }
    }
}
exports.PreorderStatusComponent = PreorderStatusComponent;
//# sourceMappingURL=preorder-status.component.js.map